'use client'

import { styled } from 'styled-components'
import { DoneOutline } from '@styled-icons/material-rounded/DoneOutline'
import { Edit2Outline } from '@styled-icons/evaicons-outline/Edit2Outline'
import { DesktopMac } from '@styled-icons/fluentui-system-regular/DesktopMac'
import { Phone } from '@styled-icons/fluentui-system-regular/Phone'
import { Tablet } from '@styled-icons/fluentui-system-regular/Tablet'
import { Glasses } from '@styled-icons/fluentui-system-regular/Glasses'
import { EditSettings } from '@styled-icons/fluentui-system-regular/EditSettings'
import { Save as SaveAnt } from '@styled-icons/fluentui-system-regular/Save'
import { CloseOutline } from '@styled-icons/evaicons-outline/CloseOutline'
import { PROD_URL } from '@/constants'

export const ContentEditorWrapper = styled.div`
  display: block;
  position: relative;
`
export const ConsoleActionBar = styled.div`
  ${({
    theme: {
      base: { grey },
    },
  }) => `
    display: flex;
    background-color: ${grey[5]};
    justify-content: space-between;
    position: fixed;
    width: 100%;
    z-index: 99;
  `}
`

export const ButtonAction = styled.button`
  ${() => `
    border-top: 0;
    border-bottom: 0;
    border-left: 0;
    border-right: 1px solid #C0C0C0;
    padding: 1rem;
    min-width: 60px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;

    &:active {
      background-color: #C0C0C0;
    }
  `}
`

export const ContainerView = styled.div`
  ${() => `
    display: flex;
    position: relative;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 100%;
    background-color: #F8F8F8;
    box-shadow: 8px 0px 10px -9px #C0C0C0;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      display: block;
      width: 40px;
      height: 40px;
      border: 2px solid ${'#484848'};
      border-radius: 50%;
    }
  `}
`

export const ConsoleWidgetContianer = styled.div`
  ${() => `
    display: grid;
    position: relative;
    grid-template-columns: 0px auto;
    grid-template-areas: "widget content";
    height: calc(100vh - 107px);
  `}
`

export const EditIcon = styled(Edit2Outline).attrs(() => ({
  size: 20,
}))`
  ${() => `
    color: ${'#484848'};
  `}
`

export const DesktopIcon = styled(DesktopMac).attrs(() => ({
  size: 25,
}))``

export const PhoneIcon = styled(Phone).attrs(() => ({
  size: 25,
}))``

export const TabletIcon = styled(Tablet).attrs(() => ({
  size: 25,
}))``

export const PreviewIcon = styled(Glasses).attrs(() => ({
  size: 25,
}))``

export const PreviewPageIcon = styled(PreviewIcon).attrs(() => ({
  size: 35,
}))``

export const ArrowBackIcon = styled(CloseOutline).attrs(() => ({
  size: 25,
}))``

export const PageSetting = styled(EditSettings).attrs({
  size: 25,
})``

export const SaveIcon = styled(SaveAnt).attrs({
  size: 25,
})``

export const LayoutGroup = styled.div`
  display: flex;
`

export const ContentContolwidth = styled.div<{ dymanicWidth?: number }>`
  ${({
    dymanicWidth = 80,
    theme: {
      base: {
        shade: { blue },
      },
    },
  }) => `
    ${dymanicWidth ? `width: ${dymanicWidth}%` : ''};
    max-width: 1440px;
    transition: width 0.5s ease-in-out;
    grid-area: content;
    margin: 80px auto 0;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    border-left: 1px solid ${blue[3]};
    border-right: 1px solid ${blue[3]};
    position: relative;

    &::after {
      position: absolute;
      display: flex;
      right: -18px;
      top: 0;
      content: '';
      width: 15px;
      height: 100%;
      border-radius: 10px;
      background-color: ${blue[3]}aa;
      z-index: -1;
    }

    &::before {
      position: absolute;
      display: flex;
      left: -18px;
      top: 0;
      content: '';
      width: 15px;
      height: 100%;
      border-radius: 10px;
      background-color: ${blue[3]}aa;
    }

    container-type: inline-size;
    container-name: editor-console;

    @media (max-width: 768px) {
      max-width: unset;
      width: 100%;
    }
  `}
`

export const BodyControlArea = styled.div`
  ${({
    theme: {
      base: {
        shade: { white },
      },
    },
  }) => `
    display: block;
    position: relative;
    flex-direction: column;
    position: relative;
    width: 100%;
    min-width: 100px;
    min-height: 1200px;
    row-gap: 10px;
    background-color: ${white[1]};
    border: 2px solid ${white[1]};
    padding-bottom: 100px;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      opacity: 0.05;
      transform: translate(-50%, -50%);
      width: 100px;
      height: 100px;
      background-image: url(${PROD_URL}/assets/images/gear.png);
      background-size: 70%;
      background-repeat: no-repeat;
      background-position: center;
      z-index: 0;
    }

    &::before {
      content: 'Builder widgets';
      position: absolute;
      text-align: center;
      top: 55%;
      left: 50%;
      font-size: 1.2rem;
      opacity: 0.05;
      font-weight: 700;
      transform: translate(-50%, -50%);
      width: 150px;
      z-index: 0;
    }
  `}
`

export const PublishContent = styled.div<{ label?: string }>`
  ${({ label = '' }) => `
  display: block;
  position: relative;
  padding: 1rem 0;

  &::after {
    content: '${label}';
    position: absolute;
    top: -10px;
    left: 0;
  }
 `}
`

export const ModalBody = styled.div`
  text-align: center;
  text-transform: uppercase;
`

export const PublishSuccess = styled(DoneOutline)`
  ${({
    theme: {
      base: {
        shade: { green },
      },
    },
  }) => `
    color: ${green[3]};
    margin: 0 1rem;
  `}
`

